/**
 * Created by cahyo on 20/02/19
 *
 */

import AppConfig from './AppConfig';

// Initialize Firebase Analytics
import './plugins/firebase';

// Console welcome message untuk production
if (process.env.NODE_ENV === 'production') {
  const welcomeMessage = () => {
    const styles = {
      title: 'font-size: 24px; font-weight: bold; color: #fc6d26; padding: 10px 0;',
      text: 'font-size: 14px; color: #333; line-height: 1.6;',
      link: 'font-size: 14px; color: #0066cc; text-decoration: underline;',
      emoji: 'font-size: 16px;',
      divider: 'color: #fc6d26; font-weight: bold;'
    };

    console.log('%c' + '='.repeat(60), styles.divider);
    console.log('%cSelamat Datang di KHAS Kempek Cirebon!', styles.title);
    console.log('%c' + '='.repeat(60), styles.divider);
    console.log('%cApakah halaman ini memerlukan perbaikan atau peningkatan?', styles.text);
    console.log('%cBuka issue atau buat merge request untuk membantu meningkatkan aplikasi ini.', styles.text);
    console.log('');
    console.log('%c🏆 %cKontribusi: %chttps://gitlab.com/simak-khas-kempek/khas-kempek-frontend', styles.emoji, 'font-weight: bold; color: #333;', styles.link);
    console.log('%c🔍 %cBuat Issue Baru: %chttps://gitlab.com/simak-khas-kempek/khas-kempek-frontend/-/issues/new', styles.emoji, 'font-weight: bold; color: #333;', styles.link);
    console.log('%c' + '='.repeat(60), styles.divider);
  };

  welcomeMessage();
}

AppConfig.init();